import { ConstantsParser } from '../../../ConstantsParser'
import { StylesParser } from '../../../StylesParser'
export class Tertiary {
  constructor() {
   this.name = 'Tertiary'
   this.content = {
      text: 'Tertiary',
      link: '#',
      event: null,
      eventData: null
    }
   this.view = this.viewHtml()
  }
  
  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    let styles = (new StylesParser(this.styles())).parse()
    styles = Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')
    return `<div
      class="${classes}"
      style="${styles}"
    >Tertiary</div>`
  }

  classes() {
    return [
      {property: 'Size', value: 'SIZE_MD'},
      {property: 'FontWeight', value: 'BOLD'},
     ]
  }

  styles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: 'rgba(138.24,115.2,115.2, 1)'}
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        phone : this.styles(),
        tablet : this.styles(),
        desktop : this.styles(),
      },
      classes: {
        phone : this.classes(),
        tablet : this.classes(),
        desktop : this.classes(),
      },
    }
  }
}